import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=6fa93abf&scoped=true"
import script from "./RecentNews.vue?vue&type=script&lang=js"
export * from "./RecentNews.vue?vue&type=script&lang=js"
import style0 from "./RecentNews.vue?vue&type=style&index=0&id=6fa93abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa93abf",
  null
  
)

export default component.exports